export default "__VITE_ASSET__b1363bb3__"